import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';

DialogAddVehicleView.propTypes = {
  item: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
  initialDriverId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function DialogAddVehicleView({ item, onCancel, onDone, initialDriverId }) {
  // MARK: ---- PROPERTIES ----
  const editMode = !!item;
  const [loading, setLoading] = useState(false);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [selectedVehicleBrand, setSelectedVehicleBrand] = useState(null);
  const [selectedVehicleModel, setSelectedVehicleModel] = useState(null);
  const [defaultDropdownVehicleModel, setDefaultDropdownVehicleModel] = useState(null);
  useEffect(() => {
    setDefaultDropdownVehicleModel({
      name: 'Dòng xe',
      role: 'VEHICLE_MODEL',
      brandId: selectedVehicleBrand?.id,
    });
  }, [selectedVehicleBrand]);
  const dropdownVehicleBrandEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="brandId_dialog"
        name="brandId_dialog"
        ignoreConfirmClick={true}
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${readyToValidate && !selectedVehicleBrand ? 'button-invalid' : ''
              }`}
            type="button"
          >
            {selectedVehicleBrand?.name ?? 'Chọn hãng xe'}
          </button>
        }
        selectedValue={selectedVehicleBrand}
        dropdownMenuItems={[{ name: 'Hãng xe', role: 'VEHICLE_BRAND' }]}
        getSubItems={async (item) => {
          return ChargeHelper.API.VehicleBrand.requestGetVehicleBrandList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.brands?.map((row) => ({
                id: row?.brandId,
                name: row?.name,
                item: row,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedVehicleBrand(value);
          setSelectedVehicleModel(null);
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        defaultValue={{
          name: 'Hãng xe',
          role: 'VEHICLE_BRAND',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedVehicleBrand(null);
              setSelectedVehicleModel(null);
            })}
          </div>
        }
      />
    );
  }, [selectedVehicleBrand, readyToValidate]);
  const dropdownVehicleModelEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="modelId_dialog"
        name="modelId_dialog"
        ignoreConfirmClick={true}
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!selectedVehicleBrand ? 'disabled' : ''
              } ${readyToValidate && !selectedVehicleModel ? 'button-invalid' : ''}`}
            type="button"
          >
            {selectedVehicleModel?.name ?? 'Chọn dòng xe'}
          </button>
        }
        selectedValue={selectedVehicleModel}
        dropdownMenuItems={[{ name: 'Dòng xe', role: 'VEHICLE_MODEL' }]}
        getSubItems={async (item) => {
          if (Utils.isValid(selectedVehicleBrand?.id))
            return ChargeHelper.API.VehicleModel.requestGetVehicleModelList(
              selectedVehicleBrand?.id,
              {
                page: item?.page || 0,
                limit: 10,
                q: item?.q || '',
              }
            ).then((data) => {
              return {
                values: data.models?.map((row) => ({
                  id: row?.modelId,
                  name: row?.name,
                  item: row,
                })),
                total: data.total,
              };
            });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedVehicleModel(value);
          setVehicleType(value?.item?.vehicleType);
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        disabled={!selectedVehicleBrand}
        defaultValue={defaultDropdownVehicleModel}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedVehicleModel(null);
            })}
          </div>
        }
      />
    );
  }, [selectedVehicleBrand, selectedVehicleModel, defaultDropdownVehicleModel, readyToValidate]);
  const [vehicleType, setVehicleType] = useState(ChargeConstants.VehicleType.CAR);
  const [plate, setPlate] = useState('');
  const [vinNumber, setVinNumber] = useState('');
  const [chargingMode, setChargingMode] = useState(ChargeConstants.VehicleChargingMode.NORMAL);
  const [evccId, setEvccId] = useState('');
  const [selectDriver, setSelectDriver] = useState(null);
  const dropdownDriverEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="driverId"
        name="driverId"
        ignoreConfirmClick={true}
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${initialDriverId ? 'disabled' : ''
              } ${readyToValidate && !Utils.isValid(selectDriver?.id) ? 'button-invalid' : ''}`}
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            type="button"
          >
            {selectDriver?.name ?? 'Chọn khách hàng'}
          </button>
        }
        disabled={!!initialDriverId}
        selectedValue={selectDriver}
        subTitleType="email"
        dropdownMenuItems={[{ name: 'Khách hàng', role: 'DRIVER' }]}
        getSubItems={async (item) => {
          return ChargeHelper.API.Driver.requestGetDriverList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.drivers?.map((row) => ({
                id: row?.userId,
                name: row?.fullname,
                item: row,
                email: row?.email,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectDriver(value);
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        defaultValue={{
          name: 'Khách hàng',
          role: 'DRIVER',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectDriver(null);
            })}
          </div>
        }
      />
    );
  }, [selectDriver, readyToValidate, initialDriverId]);
  const plateComposingRef = useRef(false);
  const sanitizePlateInput = (raw) =>
    (raw ?? '')
      .toString()
      .replace(/[^0-9A-Za-z.Đđ-]/g, '')
      .slice(0, 10);
  const normalizePlate = (raw) =>
    (raw ?? '')
      .toString()
      .toUpperCase()
      .replace(/[^0-9A-Z.Đ-]/g, '')
      .slice(0, 10);

  useEffect(() => {
    if (item) {
      setPlate(normalizePlate(item.plate));
      setVinNumber(item.vinNumber ?? '');
      setVehicleType(item.vehicleType);
      setChargingMode(item.chargingMode ?? ChargeConstants.VehicleChargingMode.NORMAL);
      setEvccId(item.evccId ?? '');
      setSelectedVehicleBrand({
        id: item?.model?.brandId,
        name: item?.model?.brand?.name,
        item: item?.model?.brand,
      });
      setSelectedVehicleModel({
        id: item?.modelId,
        name: item.model?.name,
        item: item?.model,
      });
      if (item?.user) {
        setSelectDriver({
          id: item?.userId,
          name: item?.user?.fullname,
          item: item?.user,
        });
      } else if (item?.userId) {
        ChargeHelper.API.Driver.requestGetDriverDetail(item.userId).then((res) => {
          setSelectDriver({
            id: res.userId,
            name: res.fullname,
            item: res,
          });
        });
      }
    } else if (initialDriverId) {
      ChargeHelper.API.Driver.requestGetDriverDetail(initialDriverId).then((res) => {
        setSelectDriver({
          id: res.userId,
          name: res.fullname,
          item: res,
        });
      });
    }
  }, [item, initialDriverId]);

  // MARK: ---- METHODS ----
  const handleSubmit = async () => {
    setReadyToValidate(true);
    const plateNorm = normalizePlate(plate);
    if (
      !Utils.isValid(plateNorm) ||
      !selectedVehicleBrand ||
      !selectedVehicleModel ||
      !Utils.isValid(selectDriver?.id)
    ) {
      ToastHelper.showError('Bạn chưa nhập đủ thông tin');
      return;
    }
    if (!plateNorm.match(AppConfigs.regex.vehiclePlate)) {
      ToastHelper.showError('Biển số không hợp lệ');
      return;
    }
    let params = {
      brandId: selectedVehicleBrand?.id ?? null,
      modelId: selectedVehicleModel?.id ?? null,
      vehicleType,
      plate: plateNorm,
      vinNumber: vinNumber || null,
      userId: selectDriver?.id ?? null,
      chargingMode,
      evccId: evccId || null,
    };
    // params = _.omitBy(params, (value) => value === null || value === undefined);
    // console.log({ params });
    // return;
    setLoading(true);
    if (editMode) {
      ChargeHelper.API.Vehicle.requestUpdateVehicle(item.vehicleId, params)
        .then((res) => {
          ToastHelper.showSuccess('Cập nhật xe thành công');
          if (onDone) onDone();
        })
        .catch((error) => {
          ToastHelper.showError('Có lỗi xảy ra');
        })
        .finally(() => {
          setLoading(false);
        });
      return;
    } else {
      ChargeHelper.API.Vehicle.requestAddVehicle(params)
        .then((res) => {
          ToastHelper.showSuccess('Thêm xe thành công');
          if (onDone) onDone();
        })
        .catch((error) => {
          ToastHelper.showError('Có lỗi xảy ra');
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <div>
      <div className="row m-0 p-0 px-2 mt-4">
        {/* hang xe */}
        <div className="col-6 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Hãng xe', true)}
            {dropdownVehicleBrandEl}
          </div>
        </div>
        {/* dong xe */}
        <div className="col-6 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Dòng xe', true)}
            {dropdownVehicleModelEl}
          </div>
        </div>
        {/* loai phuong tien */}
        <div className="col-6 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Loại phương tiện', true)}
            <KTBSDropdown
              name="vehicleType"
              toggleElement={
                <button
                  className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between dropdown-disabled"
                  type="button"
                >
                  {_.find(
                    ChargeHelper.Data.vehicleTypeOptions,
                    (item) => item.value === vehicleType
                  )?.name ?? 'Chọn loại xe'}
                </button>
              }
              selectedValue={vehicleType}
              dropdownMenuItems={ChargeHelper.Data.vehicleTypeOptions}
              dropdownMenuClassName="overflow-auto w-100"
              dropdownMenuStyle={{ maxHeight: '30vh' }}
              onChange={(value) => {
                setVehicleType(value);
              }}
              isDropdownForm={true}
              disabled={true}
            />
          </div>
        </div>
        {/* bien so xe */}
        <div className="col-6 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Biển số xe', true)}
            <KTFormInput
              type={KTFormInputType.text}
              placeholder="Nhập biển số ví dụ: 29A-123.45"
              name="plate"
              value={plate}
              maxLength={10}
              onCompositionStart={() => {
                plateComposingRef.current = true;
              }}
              onCompositionEnd={(e) => {
                plateComposingRef.current = false;
                setPlate(normalizePlate(e?.target?.value));
              }}
              onBlur={() => {
                setPlate((p) => normalizePlate(p));
              }}
              onChange={(value) => {
                if (plateComposingRef.current) {
                  setPlate(value);
                  return;
                }
                setPlate(sanitizePlateInput(value));
              }}
              enableCheckValid={readyToValidate}
              isValid={
                Utils.isValid(plate) &&
                normalizePlate(plate).match(AppConfigs.regex.vehiclePlate)
              }
              isTouched={readyToValidate}
              feedbackText={
                !Utils.isValid(plate) ||
                !normalizePlate(plate).match(AppConfigs.regex.vehiclePlate)
                  ? 'Biển số không hợp lệ'
                  : ''
              }
            />
          </div>
        </div>
        {/* khach hang */}
        <div className="col-6 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Khách hàng', true)}
            {dropdownDriverEl}
          </div>
        </div>
        {/* che do sac */}
        <div className="col-6 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Chế độ sạc', true)}
            <KTBSDropdown
              name="chargingMode"
              toggleElement={
                <button
                  className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                  type="button"
                >
                  {_.find(
                    ChargeHelper.Data.vehicleChargingModeOptions,
                    (item) => item.value === chargingMode
                  )?.name ?? 'Chọn chế độ sạc'}
                </button>
              }
              selectedValue={chargingMode}
              dropdownMenuItems={ChargeHelper.Data.vehicleChargingModeOptions}
              dropdownMenuClassName="overflow-auto w-100"
              dropdownMenuStyle={{ maxHeight: '30vh' }}
              onChange={(value) => {
                setChargingMode(value);
              }}
              isDropdownForm={true}
            />
          </div>
        </div>
        {/* ma MAC/EVCC */}
        <div className="col-6 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Mã MAC/EVCC')}
            <KTFormInput
              type={KTFormInputType.text}
              placeholder="Nhập mã MAC/EVCC"
              name="evccId"
              value={evccId}
              onChange={(value) => {
                setEvccId(value);
              }}
            />
          </div>
        </div>
        {/* so khung */}
        <div className="col-6 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Số khung')}
            <KTFormInput
              type={KTFormInputType.text}
              placeholder="Nhập số khung"
              name="vinNumber"
              value={vinNumber}
              onChange={(value) => {
                setVinNumber(value);
              }}
              enableCheckValid={readyToValidate}
              isValid={
                !Utils.isValid(vinNumber) || (Utils.isValid(vinNumber) && vinNumber.toString().match(AppConfigs.regex.vinNumber))
              }
              isTouched={readyToValidate}
              feedbackText={
                Utils.isValid(vinNumber) && !vinNumber.toString().match(AppConfigs.regex.vinNumber)
                  ? 'Số khung không đúng định dạng'
                  : ''
              }
            />
          </div>
        </div>
      </div>
      {/* footer */}
      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Bỏ qua', onCancel, null)}
        {UIHelper.buildGreenButton(
          !editMode ? 'Thêm' : 'Cập nhật',
          handleSubmit,
          null,
          false,
          loading
        )}
      </div>
    </div>
  );
}

export default DialogAddVehicleView;
